import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame", "termField", "sendButton"];

  connect() {
    this.#refreshSendButton();
  }

  quotesUpdated() {
    this.#refreshSendButton();
  }

  prepareSend() {
    if (this.hasTermFieldTarget) this.termFieldTarget.value = this.#selectedTerm();
  }

  #selectedTerm() {
    const checked = this.element.querySelector('input[name="financing_term"]:checked');
    return checked ? checked.value : "";
  }

  #refreshSendButton() {
    if (!this.hasSendButtonTarget) return;
    const hasOptions = !!this.frameTarget.querySelector('input[name="financing_term"]');
    this.sendButtonTarget.disabled = !hasOptions;
  }
}
